/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum NotificationsPageDialogTypes {
    EmailServerSettings = 'EmailServerSettings',
}
